import type { CollectionEventVisualConfig } from '../types';
import { VisualConfigType } from '../types';
import { collectionEventPredefinedStyles } from './collectionEventPredefinedStyles';

export function preloadCollectionEventAssets(visuals: CollectionEventVisualConfig): Promise<boolean> {
  if (visuals.configType === VisualConfigType.Custom) {
    throw new Error('Custom visuals are not supported');
  }

  return collectionEventPredefinedStyles[visuals.visualType].preload();
}
